export enum AddMinutesTypeEnum {
    CALL_TO_CONTACT = 'Call-to-Contact minutes',
    SUPPORT_CALL = 'Support Call minutes'
}